export default {
    path: '/Payment',
    meta: {
        title: '收银台',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Payment`),
}


// WEBPACK FOOTER //
// ./src/views/Payment/router.js